// extracted by mini-css-extract-plugin
module.exports = {"link":"Featured_link__dvDJB"};